export default __webpack_public_path__ + "static/media/Group 212.66a4e388.png";